import { motion } from "framer-motion";

const MAQUITO_URL = "https://customer-assets.emergentagent.com/job_maquito-helper/artifacts/tfyykh0b_chat.svg";

// Function to render basic markdown (bold text)
function renderMarkdown(text) {
  if (!text) return text;
  
  // Split by **text** pattern and render bold
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  
  return parts.map((part, index) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={index}>{part.slice(2, -2)}</strong>;
    }
    return part;
  });
}

export default function MessageBubble({ role, content, timestamp }) {
  const isUser = role === "user";
  
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
      className={`flex gap-3 ${
        isUser ? 'flex-row-reverse' : 'flex-row'
      }`}
      data-testid={`message-bubble-${role}`}
    >
      {!isUser && (
        <img 
          src={MAQUITO_URL} 
          alt="Maquito" 
          style={{ width: '71px', height: 'auto', objectFit: 'contain' }}
          className="flex-shrink-0"
          data-testid="message-avatar"
        />
      )}
      <div
        className={`max-w-[70%] rounded-2xl px-4 py-3 ${
          isUser 
            ? 'bg-slate-100 text-slate-900' 
            : 'bg-green-100 text-slate-900'
        }`}
        data-testid="message-content"
      >
        <p className="text-sm leading-relaxed whitespace-pre-wrap">{renderMarkdown(content)}</p>
        {timestamp && (
          <p className="text-xs text-slate-500 mt-1">
            {new Date(timestamp).toLocaleTimeString('es-CL', { hour: '2-digit', minute: '2-digit' })}
          </p>
        )}
      </div>
    </motion.div>
  );
}